/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type EOBExtractionJobStatus = typeof EOBExtractionJobStatus[keyof typeof EOBExtractionJobStatus];


export const EOBExtractionJobStatus = {
  Initiated: 'Initiated',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;
